// src/redux/api/aiUsageApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const aiUsageApi = createApi({
  reducerPath: 'aiUsageApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['AIUsage'], // Tags for cache invalidation
  endpoints: (builder) => ({
    getGlobalStats: builder.query({
      query: () => '/admin/ai_usage/stats/global',
      providesTags: ['AIUsage'], // Marks this query with GlobalStats tag
    }),
    getStatsByFeature: builder.query({
      query: () => '/admin/ai_usage/stats/by-feature',
      providesTags: ['AIUsage'], // Marks this query with FeatureStats tag
    }),
    getStatsByModel: builder.query({
      query: () => '/admin/ai_usage/stats/by-model',
      providesTags: ['AIUsage'], // Marks this query with ModelStats tag
    }),
    getAiUsageYearlyStats: builder.query({  
        query: ({year}) => `/admin/ai_usage/stats/yearly?year=${year}`,
        providesTags: ['AIUsage'], // Marks this query with YearlyStats tag
    }),
    getAiUsageAllStats: builder.query({
        query: ({year}) => `/admin/ai_usage/stats/all?year=${year}`,
        providesTags: ['AIUsage'], // Marks this query with AllStats tag
     })
  }),
});

export const {
  useGetGlobalStatsQuery,
  useGetStatsByFeatureQuery,
  useGetStatsByModelQuery,
  useGetAiUsageYearlyStatsQuery,
  useGetAiUsageAllStatsQuery    
} = aiUsageApi;
